var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-3",staticStyle:{"height":"300px"}},[_c('map-base',{ref:"mapBase",attrs:{"markers":_vm.markers,"zoom":_vm.zoom,"mapOptions":_vm.mapOptions},on:{"handleClickEvent":_vm.handleMapClick}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }